import React from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import { Navbar, Nav } from 'react-bootstrap';
import styled from 'styled-components';
import data from '../Assets/data.json';
import 'bootstrap/dist/css/bootstrap.min.css';

const Wrapper = styled.div`
  position: fixed;
  width: 100%;
  background-color: #EDFCFF;
  z-index: 1;
  
  @media(min-width: 768px) {
    padding: 0 20%;
  }
  
  @media(max-height: 900px) and (min-width: 1024px) {
    padding: 0 14%;
  }
`;

const StyledNavLink = styled(Nav.Link)`
  @media(min-width: 992px) {
    margin-right: 4rem;
  }
`;

const StyledSignUp = styled(Nav.Link)`
  padding-left: 0.8rem !important;
  padding-right: 0.8rem !important;
  background-color: #ACD7FF;
  border-radius: 10px;
  font-weight: bolder;
  text-align:  center;
`;

const StyledNav = styled(Nav)`
  align-items: center;
`;

const StyledHashLink = styled(HashLink)`
  color: black;
  opacity: 70%;
  
  &:hover {
    color: black;
    opacity: 100%;
    text-decoration: none;
  }
`;

const StyledLink = styled(Link)`
  color: black;
  opacity: 70%;
  
  &:hover {
    color: black;
    opacity: 100%;
    text-decoration: none;
  }
`;

const Header = () => {
    return (
        <Wrapper>
            <Navbar collapseOnSelect expand='lg'>
                <Navbar.Brand href='/#'>
                    <StyledHashLink to="/#"><strong>{data.header.brand}</strong></StyledHashLink>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls='responsive-navbar-nav'/>
                <Navbar.Collapse className='justify-content-end' id='responsive-navbar-nav'>
                    <StyledNav>
                        <StyledNavLink><StyledHashLink to="/#">{data.header.home}</StyledHashLink></StyledNavLink>
                        <StyledNavLink><StyledHashLink
                            to="/#offer-section">{data.header.offer}</StyledHashLink></StyledNavLink>
                        <StyledNavLink><StyledHashLink
                            to="/#contact-section">{data.header.contact}</StyledHashLink></StyledNavLink>
                        <StyledSignUp><StyledLink to="/signform">{data.header.sign}</StyledLink></StyledSignUp>
                    </StyledNav>
                </Navbar.Collapse>
            </Navbar>
        </Wrapper>
    );
};

export default Header;
